/* eslint-disable @typescript-eslint/no-namespace */
import { DealVersion } from '../../types/deal.types';

export namespace DealsSize {
  export function getFullTotals(deals: DealVersion[]): number {
    return deals.reduce((acc: number, deal: DealVersion) => acc + deal.size, 0);
  }

  export function getMillionTotals(deals: DealVersion[]) {
    return getFullTotals(deals) / 1000;
  }

  export function getSortedBySize(deals: DealVersion[]): DealVersion[] {
    return deals
      .concat()
      .sort((a: DealVersion, b: DealVersion) => b.size - a.size);
  }
}
